import { render, staticRenderFns } from "./PointProgram.vue?vue&type=template&id=709232d6&"
import script from "./PointProgram.vue?vue&type=script&lang=js&"
export * from "./PointProgram.vue?vue&type=script&lang=js&"
import style0 from "./PointProgram.vue?vue&type=style&index=0&id=709232d6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports